
<div>
  <div id="slider" ref="slider"></div>
</div>
